// Every tooltip box is a manual popover, so it renders in the top layer. A box
// appended to body would sit behind an open dropdown menu (or dialog), and one
// appended to the menu would be clipped by its scroll container.
//
// There is no hidePopover(): the box stays open through Tippy's fade-out,
// and Tippy's unmount removes it from the DOM, which closes the popover.
// Hiding it on onHide would set display: none before the transition, so
// transitionend would never fire and Tippy would never unmount it.
//
// Tippy reuses the box, so from the second show on it is still a closed
// popover (display: none) when Popper measures it, and Popper places it as
// if it had no width. Placing it again once it is open fixes that.
//
// Tippy appends an interactive tooltip to its reference's parent, which
// keeps content with a data-action inside the controller that handles it,
// and inside the dialog when the reference is in one. Any other tooltip
// goes to body, unless its reference is in an open modal dialog: the modal
// makes the rest of the page inert, so a box in body couldn't be hovered,
// and it is appended to the dialog instead.
//
// Callers spread these options, so one that sets its own onCreate or
// onMount has to call these too.
export const topLayerOptions = {
  onCreate(instance) {
    if (instance.props.interactive) return;
    const dialog = instance.reference.closest("dialog");
    if (dialog) instance.setProps({ appendTo: dialog });
  },
  popperOptions: { strategy: "fixed" },
  onMount(instance) {
    const box = instance.popper;
    box.setAttribute("popover", "manual");
    if (typeof box.showPopover === "function") {
      box.showPopover();
      instance.popperInstance?.forceUpdate();
    }
  },
};
